var requestOptions = {
  method: "GET",
  redirect: "follow",
};

$(function () {
  var fscode = getUrlParameter("discount");
  //console.log('getting discount code from URL: '+fscode);
  if (typeof(fscode) !== 'undefined' && fscode !== null && fscode.length > 0 && fscode != false) {
    $.cookie("discount_code", fscode, { expires: 1, path: '/' });
    window.location.href = '/discount/' + fscode + '?redirect=' + window.location.pathname;
  }

  if ($.cookie("discount_code") != null) {
    //console.log('getting discount code from cookie: '+$.cookie("discount_code"));
    loadDiscount();
  }

  $(document).ajaxComplete(function () {
    loadDiscount();
  });

});

async function loadDiscount() {
  var chn = 1;
  const response = await fetch("https://sales.futuresalad.com/shopify/discounts/" + chn + "/" + $.cookie("discount_code"), requestOptions);
  const discounts = await response.json();
  if (!$.isEmptyObject(discounts.data)) {
    discounts.data.forEach((d) => {
      priceItems = $('.fs-dynamic-price[data-variant-id='+d.vid+']');
      if (!$.isEmptyObject(priceItems)) {
        for (var price of priceItems) {
					originalPrice = price.dataset.originalPrice;
					currency = price.dataset.priceCurrency;
					currencySymbol = price.dataset.priceCurrencySymbol;
          if (!!originalPrice) {
            price.innerHTML = replacePriceHtml(originalPrice, d.dv, chn, currency, currencySymbol);
          }
        }
      };
      percentageItems = $('.fs-dynamic-price-off-tag[data-variant-id='+d.vid+']');
      if (!$.isEmptyObject(percentageItems)) {
        for (var perc of percentageItems) {
          perc.innerHTML = (parseFloat(d.dv) * -100.0).toFixed(0) + "%";
				}
			};
			
    });
  }
}

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

function replacePriceHtml(inputOriginalPrice, discountValue, lang, cur, sym) {
  var originalPrice = (parseFloat(inputOriginalPrice) / 100.0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  var discountedPrice = (Math.ceil((1 - (parseFloat(discountValue) * -1 )) * inputOriginalPrice) / 100.0 ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return `<span class="price sale">
    <span data-product-price class="new-price product__price--sale">`+sym+discountedPrice+` `+cur+`</span>
    <span data-compare-price class="old-price product__price--strike">`+sym+originalPrice+` `+cur+`</span>
	</span>`;
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};